module.exports = __webpack_public_path__ + "img/notify.c98efffc.png";